<template>
  <div>
    <CCard
      title="Plan"
    >
      <CCardHeader>
        <CRow>
          <CCol col=4>
            <CIcon size="2xl" name="cil-grid"/> Plan
          </CCol>
          <CCol col=8 class="align-right">
            <CButtonToolbar>
              <input 
                class="search" 
                type="search"
                v-model="findKeyword"
                v-on:input="handleKeyword"
                placeholder="โครงการ, ปีงบประมาณ, ความเป็นเจ้าของ, ชนิด"
              >
              &nbsp;
              <CButtonGroup>
                <CButton
                  v-on:click="isCreateOrEditPlan = true; selectedPlan = {};"
                  name="manage"
                  color="primary"
                  class="d-sm-down-none"
                >
                  Create
                </CButton>
                
              </CButtonGroup>
            </CButtonToolbar>
          </CCol>
        </CRow>

      </CCardHeader>
      <CCardBody>
        <CDataTable
          :hover="false"
          :striped="true"
          :border="true"
          :small="false"
          :fixed="false"
          :items-per-page="20"
          :dark="false"
          pagination
          :items="plansTable"
          :fields="plansTableFields"
        >
          <template #operation="{item}">
            <td>
              <CButton
                v-on:click="handleSelectedPlan(item); isCreateOrEditPlan = true"
                name="manage"
                color="primary"
              >
                Edit
              </CButton>
              <CButton
                v-on:click="handleSelectedPlan(item); deletePlan()"
                name="delete"
                color="danger"
                :disabled="!isDeletabled"
              >
                Delete
              </CButton>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
      <CCardFooter>
        <CRow>
          <CCol sm="6" md="1">
            <CSwitch class="mx-1" color="primary" v-on:update:checked="toggleDelete" :checked="!isDeletabled" variant="opposite" shape="pill" labelOn='yes' labelOff='no' />
          </CCol>
          <CCol sm="6" md="11">
            <p>Prevent Delete Plan</p>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
        
    <CModal
      :show.sync="isCreateOrEditPlan"
      :centered="false"
      color="primary"
      title="Plan Information"
      size="lg"
    >
      <CForm>
        <CInput
          v-model="selectedPlan.project"
          type="text"
          label="หน่วยงานที่ใช้"
          placeholder="ชื่อโครงการ..."
          horizontal
          required
          :is-valid="isValidPlan('project')"
          :invalid-feedback="feedback.project"
        />
        <CSelect
          label="ปีงบประมาณ"
          horizontal
          :value.sync="selectedPlan.project_year"
          :options="[2024,2025,2026,2027]"
          placeholder="Please select"
          :is-valid="isValidPlan('project_year')"
        />
        <CCmonth
          label="เดือนที่คาดว่าจะได้รับยานพาหนะ"
          :startYear="2024"
          :endYear="2028"
          :required="true"
          :horizontal="true"
          :value="selectedPlan['delivered_month']"
          @input="eventUpdateMonth($event)"
        />
        <CSelect
          label="ชนิดรถไฟฟ้า"
          horizontal
          :value.sync="selectedPlan.ev_type"
          :options="selectEVTypeOption"
          placeholder="Please select"
          :is-valid="isValidPlan('ev_type')"
        />
        <CSelect
          label="รูปแบบการใช้บริการ"
          horizontal
          :value.sync="selectedPlan.usage_type"
          :options="selectUsageTypeOption"
          placeholder="Please select"
          :is-valid="isValidPlan('usage_type')"
        />
        <!-- <CInput
          v-model="selectedPlan.battery_size"
          type="text"
          label="ขนาดแบตเตอรี่ (kWh)"
          placeholder="Enter battery size..."
          horizontal
          required
          :is-valid="isValidPlan('battery_size')"
          :invalid-feedback="feedback.battery_size"
        /> -->
        <CCNumber
          v-model="selectedPlan.battery_size"
          type="text"
          :allowNaN="false"
          label="ขนาดแบตเตอรี่ (kWh)"
          placeholder="Enter battery size..."
          horizontal
          required
          :is-valid="isValidPlan('battery_size')"
          :invalid-feedback="feedback.battery_size"
        />
        <CCNumber
          v-model="selectedPlan.amount"
          type="text"
          :allowNaN="false"
          label="จำนวนรถ (คัน)"
          placeholder="Enter จำนวนรถ (คัน)..."
          horizontal
          required
          :is-valid="isValidPlan('amount')"
          :invalid-feedback="feedback.amount"
        />
        <CSelect
          label="ลักษณะความเป็นเจ้าของ"
          horizontal
          :value.sync="selectedPlan.ownership"
          :options="selectOwnershipOption"
          placeholder="Please select"
          :is-valid="isValidPlan('ownership')"
        />
        <CSelect
          label="สถานะโครงการ"
          horizontal
          :value.sync="selectedPlan.state"
          :options="selectStateOption"
          placeholder="Please select"
          :is-valid="isValidPlan('state')"
        />
      </CForm>
      <template #footer>
        <CButton v-on:click="isCreateOrEditPlan = false" color="light">Cancel</CButton>
        <CButton
          v-if="isNewPlan"
          v-on:click="isCreateOrEditPlan = false; createPlan();"
          :disabled="!isValidSelectedPlan"
          color="success"
        >
          Create
        </CButton>
        <CButton
          v-if="!isNewPlan"
          v-on:click="isCreateOrEditPlan = false; updatePlan();"
          color="success"
          :disabled="!isValidSelectedPlan"
        >
          Save
        </CButton>
        
        
      </template>
    </CModal>

    <Snackbar :isActivated="isAlert" :message="alertMessage" :color="alertColor"></Snackbar>

  </div>
</template>

<script>
import config  from '@/config'
import { axiosInstance } from '@/api'
// import { range, parseQueryString, parseBoolString, stringToHex } from '@/utils'

import Snackbar from '@/vue/base/Snackbar.vue'
import CCmonth from '@/vue/base/CCmonth.vue'
import CCNumber from '@/vue/base/CCNumber.vue'

import '@/assets/scss/search_box.scss'


import Ajv from "ajv"
import { TRUE } from 'sass'


const ajv = new Ajv()

export default {
  name: 'Plan',
  components: { Snackbar, CCmonth, CCNumber },
  data () {
    return {
      isDeletabled: false,
      isManageInfo: false,
      isManagePlan: false,
      isCreateOrEditPlan: false,
      isAlert: false,
      alertCountDown: 0,
      alertColor: 'info',
      alertMessage: '',
      findKeyword: '',
      feedback: {},
      
      PlanSchema: {},
      plan: {},
      plans: [],
      selectedPlan: {},
      plansTableFields:  [
        { key: 'project', label: 'ชื่อโครงการ' },
        { key: 'project_year', label: 'ปีงบประมาณ' },
        // { key: 'delivered_month', label: 'เดือนที่คาดว่าจะได้รับยานพาหนะ' },
        { key: 'ev_type', label: 'ชนิดรถไฟฟ้า' },
        { key: 'usage_type', label: 'รูปแบบการใช้งาน' },
        // { key: 'battery_size', label: 'ขนาดแบตเตอรี่ (kWh)' },
        // { key: 'amount', label: 'จำนวนรถ (คัน)' },
        { key: 'ownership', label: 'ลักษณะความเป็นเจ้าของ' },
        { key: 'state', label: 'สถานะโครงการ' },
        { key: 'operation', label: 'Operation' }
      ],
      selectEVTypeOption: ["ev","hev","phev"],
      selectUsageTypeOption: [
        {
          value: 'car',
          label: 'นั่งส่วนบุคคล'
        },
        {
          value: 'bus',
          label: 'โดยสาร'
        },
        {
          value: 'truck',
          label: 'ขนส่งสินค้า'
        },
      ],
      selectOwnershipOption: [
        { 
          value: 'own', 
          label: 'รถซื้อ'
        },
        { 
          value: 'rent', 
          label: 'รถเช่า'
        },
      ],
      selectStateOption: [
        {
          value: 'progressed', 
          label: 'ดำเนินการแล้ว'
        },
        { 
          value: 'progressing', 
          label: 'กำลังดำเนินงาน'
        },
        { 
          value: 'planed', 
          label: 'วางแผนการดำเนินงาน'
        },
      ],
      selectManufacturingYearOption: [
      ],
      // selectedMonthYear: "", // Model to hold the selected date
    }
  },
  computed: {
    plansTable () {
      let plans = []
      for(let i = 0; i < this.plans.length; i++) {
        let plan = Object.assign({},this.plans[i])
        plan['usage_type'] = this.findLabelByValue(this.selectUsageTypeOption , plan['usage_type'])
        plan['ownership'] = this.findLabelByValue(this.selectOwnershipOption, plan['ownership'])
        plan['state'] = this.findLabelByValue(this.selectStateOption, plan['state'])
        // plan['engine_size'] = plan['engine_size'] ?? ''
        // plan['battery_size'] = plan['battery_size'] ?? ''

        plans.push(plan)
      }
      
      let filteredPlans = []
      for(let i = 0; i < plans.length; i++) {
        if (
          plans[i]['project'].includes(this.findKeyword)
          || plans[i]['project_year'].toString().includes(this.findKeyword)
          || plans[i]['ev_type'].includes(this.findKeyword)
          || plans[i]['usage_type'].includes(this.findKeyword)
          || plans[i]['ownership'].includes(this.findKeyword)
          || plans[i]['state'].includes(this.findKeyword)
        ) {
          filteredPlans.push(plans[i])
        }
      }
      return filteredPlans
    },
    isValidSelectedPlan () {
      const isValid = ajv.validate(this.PlanSchema, this.selectedPlan)
      if (!isValid) { 
        return false
      } else {
        return true
      }
    },
    isNewPlan () {
      if(Object.hasOwn(this.selectedPlan, 'id')) {
        if (typeof this.selectedPlan.id === 'number') {
          return false
        }
      }
      return true
    },
  },
  mounted() {
    this.getPlanSchema()
    this.getPlan()
  },
  watch: {
  },
  methods: {
    reprocessPlanByFuelType(event) {
      // console.log('on change fuel type: '+event)
      // console.log(event)
      this.selectedPlan.fuel_type = event.target.value
      switch (event.target.value) {
        case 'electric':
          delete this.selectedPlan.engine_size
          break;
        case 'diesel':
        case 'bensin':
        case 'e20':
        case 'e85':
        case 'lpg':
        case 'ngv':
          delete this.selectedPlan.battery_size
          break;
        default:
          break;
      }
    },
    eventUpdateMonth(value) {
      console.log('event: update month: '+ value)
      this.$set(this.selectedPlan, "delivered_month", value); // Updates the property reactively
    },
    findLabelByValue(options, searchValue) {
      const foundOption = options.find(option => option.value === searchValue)
      return foundOption ? foundOption.label : ''
    },
    toggleDelete () {
      this.isDeletabled = !this.isDeletabled
    },
    isValidPlan (key) {
      if (this.PlanSchema) {
        if (Object.hasOwn(this.selectedPlan, key)) {
          // console.log('key: ' + key + ' is exist')
          const isValid = ajv.validate(this.PlanSchema.properties[key], this.selectedPlan[key])
          if (isValid) {
            return true
          } else {
            if (!this.PlanSchema['required'].includes(key) && this.selectedPlan[key] === '') {
              // console.log('key: ' + key + ' is exist, not require, and empty then delete !!!')
              delete this.selectedPlan[key]
              return true
            } else {
              // console.log('key: ' + key + ' is exist and not empty')
              this.feedback[key] = ajv.errors[0].message
              return false
            }
          }
        } else {
          // console.log('key: ' + key + ' is not exist')
          if (this.PlanSchema['required'] && !this.PlanSchema['required'].includes(key)) {
            // console.log('key: ' + key + ' is not require')
            return true
          } else {
            // console.log('key: ' + key + ' is require !!!')
            return false
          }
        }
      } else {
        return false
      }
    },
    handleKeyword () {
      // Nothing to do, the keyword is used in computed()
    },
    handleSelectedPlan (plan) {
      let data = {}
      for(let i = 0; i < this.plans.length; i++) {
        if (this.plans[i].id == plan.id) {
          data = Object.assign({},this.plans[i])
        }
      }
      
      delete data.createdAt
      delete data.updatedAt
      this.selectedPlan = data

      // this.isCreateOrEditPlan = true
    },
    getPlanSchema () {
      axiosInstance({
        method: 'get',
        url: '/plan/schema'
      })
      .then(response => {
        if(response.status === 200) {
          let schemas = {}
          Object.assign(schemas, response.data)
          let properties = {}
          Object.assign(properties, schemas.properties)
          delete schemas.properties
          schemas.properties = {}
          for (const [key, value] of Object.entries(properties)) {
            delete value.hint
            schemas.properties[key] = value
          }
          this.PlanSchema = schemas
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    getPlan () {
      axiosInstance({
        method: 'get',
        url: '/plan/'
      })
      .then(response => {
        // console.log(`get Plan: ${JSON.stringify(response.data, null, 2)}`)
        if(response.status === 200) {
          this.plans = response.data
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    updatePlan () {
      axiosInstance({
        method: 'put',
        url: '/plan/',
        data: this.selectedPlan
      })
      .then(response => {
        if(response.status === 200) {
          this.plan = Object.assign({},response.data)
          this.alertColor = 'success'
          this.alertMessage = 'update plan success'
          this.isAlert = !this.isAlert
          // this.getPlan()
          // ### replace plan by id
          for(let i = 0; i < this.plans.length; i++) {
            if (this.plans[i].id == response.data.id) {
              this.plans.splice(i,1)
              this.plans.push(response.data)
              break
            }
          }
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          // console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
          this.alertColor = 'danger'
          this.alertMessage = `Error [${error.response.status}]: ${JSON.stringify(error.response.data)}`
          this.isAlert = !this.isAlert
        }
      })
    },
    createPlan () {
      axiosInstance({
        method: 'post',
        url: '/plan/',
        data: this.selectedPlan
      })
      .then(response => {
        if(response.status === 200) {
          this.plan = Object.assign({},response.data)
          this.alertColor = 'success'
          this.alertMessage = 'create plan success'
          this.isAlert = !this.isAlert

          // this.getPlan()
          this.plans.push(response.data)
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          // console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
          this.alertColor = 'danger'
          this.alertMessage = `Error [${error.response.status}]: ${JSON.stringify(error.response.data)}`
          this.isAlert = !this.isAlert
        }
      })
    },
    deletePlan () {
      axiosInstance({
        method: 'delete',
        url: '/plan/',
        data: this.selectedPlan
      })
      .then(response => {
        if(response.status === 200) {
          // console.log(`response.data: ${JSON.stringify(response.data, null, 2)}`)
          // this.plan = response.data
          this.alertColor = 'success'
          this.alertMessage = 'update plan success'
          this.isAlert = !this.isAlert

          // this.getPlan()
          for(let i = 0; i < this.plans.length; i++) {
            if (this.plans[i].id == this.selectedPlan.id) {
              this.plans.splice(i,1)
              break
            }
          }
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          // console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
          this.alertColor = 'danger'
          this.alertMessage = `Error [${error.response.status}]: ${JSON.stringify(error.response.data)}`
          this.isAlert = !this.isAlert
        }
      })
    },

  }
}
</script>

<style scoped lang="scss">
  // .table-header {
  //   font-size: 1rem;
  //   margin-bottom: -15px;
  // }

  /* Center align content in the first column */
  .align-center {
    // text-align: center;
    display: flex;
    align-items: center; /* Vertical alignment */
    justify-content: center; /* Horizontal alignment */
  }

  /* Right align content in the second column */
  .align-right {
    display: flex;
    align-items: right; /* Vertical alignment */
    justify-content: right; /* Horizontal alignment */
  }
</style>